import { useEffect, useRef } from 'react';
import { UseFormReturn, Path, FieldValue, FieldValues } from 'react-hook-form';
import { FormFields } from 'utils/types';
import { useEffectDebounce } from 'AurionCR/components/hooks';

interface Options<T extends FieldValues> {
  setValue: UseFormReturn<FormFields<T>>['setValue'];
  watch: UseFormReturn<FormFields<T>>['watch'];
  name: Path<FormFields<T>>;
  skip?: boolean;
  emptyValue?: any;
}

export const useFormDefaultValue = <T extends FieldValues>(
  defaultValue: FieldValue<T> | undefined,
  options: Options<T>,
) => {
  const { name, watch, setValue, skip = false, emptyValue = undefined } = options;

  const value = watch(name);
  const setValueRef = useRef(setValue);
  useEffect(() => {
    setValueRef.current = setValue;
  }, [setValue]);

  useEffectDebounce(
    () => {
      if (value === emptyValue && defaultValue && skip === false) {
        setValueRef.current(name, defaultValue);
      }
    },
    100,
    [value, defaultValue, name, skip],
  );
};
